import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ERROR_STATE,ErrorHandlingAction } from '../common';

export interface ErrorHandlerState {
	message: string;
	type: ERROR_STATE;
	open: boolean;
}
const initialState: ErrorHandlerState= {
	message: '',
	type: 'warning',
	open: false,
};

const errorHandlingSlice = createSlice({
  name:'errorHandling',
  initialState,
  reducers:{
    SEND_MESSAGE:(state, action:PayloadAction<any>):ErrorHandlerState=>{
      return{
        ...state,
				type: action.payload.type,
				message: action.payload.message,
				open: true,
      }
    },
    SEND_SNACKBAR_CLEAR:(state, action:PayloadAction<any>):ErrorHandlerState=>{
      return{
        ...state,
				type: '',
				message: '',
				open: false,
      }
    }
  }
})

export const { SEND_MESSAGE ,SEND_SNACKBAR_CLEAR} = errorHandlingSlice.actions
export default errorHandlingSlice.reducer
